<h1 class="text-center auth-heading">
  <img src="assets/layout/images/wtg-logo-transparent-white.webp" alt="wtg watch this garage logo" class="app-logo">
  <small>{{'auth.registration.confirmation.title' | translate}}</small>
</h1>
<ng-container *ngIf="success; else processing">
  <p class="text-center">{{message}}</p>
  <div class="confirmation-cta">
    <button pButton pRipple
            [routerLink]="['/login']"
            type="button"
            icon="pi pi-sign-in"
            iconPos="left"
            class="auth-action--primary"
            [label]="'auth.login.button.sign_in' | translate"
    >
    </button>
  </div>
</ng-container>
<ng-template #processing>
  <p class="text-center">{{message || ('auth.registration.confirmation.processing' | translate)}}</p>
</ng-template>
